import { Ref, WatchStopHandle } from 'vue';
import omit from 'lodash/omit';
import isNumber from 'lodash/isNumber';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

const NEED_RESTARTED_PROP = ['enableBloom', 'toggleAnimation'];


const transformColorList = (data: GridLayerColorListType[]) => data.map(item => item.value);

export default function useGridLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<GridLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config || !TMap.visualization?.Grid) return;
  const options = omit(layerInfo.value.config, LAYER_CONFIG_OMIT_PROP);

  let unwatchList: WatchStopHandle[] | null = [];
  const gridOptions = {
    ...omit(options, ['zoomRange', 'colorList']),
    colorList: options.colorList && transformColorList(options.colorList),
    minZoom: options.zoomRange?.[0],
    maxZoom: options.zoomRange?.[1],
  };
  const gridLayer = new TMap.visualization.Grid(gridOptions);
  gridLayer.addTo(mapInstance);
  unwatchList.push(watchEffect(() => {
    try {
      gridLayer?.setData(layerInfo.value.config.data);
    } catch (error) {
      gridLayer?.setData([]);
    }
  }));

  Object.keys(options).forEach((key) => {
    unwatchList?.push(watch(() => layerInfo.value.config[key], (newVal) => {
      if (NEED_RESTARTED_PROP.includes(key)) {
        gridLayer.unmount();
        useGridLayer(mapInstance, layerInfo);
      } else {
        gridOptionsHandlers[key](newVal, gridLayer);
      }
    }, { deep: true }));
  });

  gridLayer.unmount = (): void => {
    gridLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };
  return gridLayer;
}

const gridOptionsHandlers = {
  sideLength(val: number, layerInstance: LooseObject): void {
    if (!isNumber(val)) {
      console.warn('请传入数字类型，当前传入的是：', val);
      return;
    }
    layerInstance.setSideLength(val);
  },
  extrudable(val: boolean, layerInstance: LooseObject): void {
    layerInstance.setExtrudable(val);
  },
  colorList(val: GridLayerColorListType[], layerInstance: LooseObject): void {
    layerInstance.setColorList(transformColorList(val));
  },
  heightRange(val: number[], layerInstance: LooseObject): void {
    layerInstance.setHeightRange(val);
  },
  showRange(val: number[], layerInstance: LooseObject): void {
    layerInstance.setShowRange(val);
  },
  selectOptions(val: LooseObject, layerInstance: LooseObject): void {
    layerInstance.setSelectOptions(val);
  },
  zoomRange(val: number[], layerInstance: LooseObject): void {
    layerInstance.setMinZoom(val?.[0]);
    layerInstance.setMaxZoom(val?.[1]);
  },
};
